import React from 'react';
import {supportedLocales} from '../../../config/i18n';
import {NavLink} from 'react-router-dom';
import {useLang, useTranslation} from '../../../config/TranslationProvider';
import classnames from 'classnames';

const LanguageSwitcher = () => {
    const {lang: currentLanguage, setLang} = useLang();

    const handleLanguage = (e, language) => {
        e.preventDefault();
        setLang(language);
    };

    const languageNames = {
        en: useTranslation('language_en'),
        de: useTranslation('language_de'),
    };

    const ariaLabels = {
        en: (locale) => `Change language to ${languageNames[locale]}`,
        de: (locale) => `Sprache umstellen auf ${languageNames[locale]}`,
    };

    return (
        <ul className="language-menu">
            {Object.keys(supportedLocales).map(locale => (
                <li key={locale}>
                    <NavLink
                        to="/"
                        onClick={e => handleLanguage(e, locale)}
                        aria-label={ariaLabels[currentLanguage](locale)}
                        aria-pressed={locale === currentLanguage}
                        className={classnames({
                            'text-decoration-underline': locale === currentLanguage,
                        })}
                    >
                        {locale.toUpperCase()}
                    </NavLink>
                </li>
            ))}
        </ul>
    );
};

export default LanguageSwitcher;
